import React from "react";
import { Box } from "@mui/material";
import BottomNav from "./BottomNav";

export const NAV_HEIGHT = 56;

// Only Home and Live Order sit behind the persistent bottom nav — Cart is a
// deliberate full-screen step reached from the floating cart bar, not a
// footer tab (no "Completed"/"Online" tabs here at all: those are staff-side
// concepts from denzo-waiter that don't apply to a guest ordering from their
// own table).
export default function MainLayout({ children }) {
  return (
    <Box sx={{ pb: `${NAV_HEIGHT}px`, minHeight: "100dvh" }}>
      {children}
      <BottomNav />
    </Box>
  );
}
